import { LogoAnimationSettings } from '../types';

const STORAGE_KEY = 'logo_animation_settings';

const defaultSettings: LogoAnimationSettings = {
  enabled: false,
  frequency: 60, // 60 seconds default
  duration: 10, // 10 seconds default
  textTemplate: '{{sender}} donated {{amount}} for {{challenge}}', // default template
};

export const logoAnimationService = {
  getSettings(): LogoAnimationSettings {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...defaultSettings, ...parsed };
      }
    } catch (error) {
      console.warn('Failed to load logo animation settings:', error);
    }
    return defaultSettings;
  },

  setSettings(settings: LogoAnimationSettings): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
      console.warn('Failed to save logo animation settings:', error);
    }
  },

  updateSetting<K extends keyof LogoAnimationSettings>(
    key: K,
    value: LogoAnimationSettings[K]
  ): void {
    const currentSettings = this.getSettings();
    const newSettings = { ...currentSettings, [key]: value };
    this.setSettings(newSettings);
  },
};

export default logoAnimationService;
